import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MaterialFolderGrid from "../components/MaterialFolderGrid";
import { getAllSubtopics } from "../helper/apicalls/subtopic";
import { getQuestionBankFolders, getQuestionBankInstitutionFolders } from "../helper/apicalls/questionBank";
import "../styles/MaterialFolder.scss";

const QuestionBankTopic = () => {
  const { coursekey, subjectkey, topickey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "course";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [courseFolders, setCourseFolders] = useState([]);
  const [institutionFolders, setInstitutionFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [subtopicsRes, foldersRes, instFoldersRes] = await Promise.all([
          getAllSubtopics(topickey),
          getQuestionBankFolders({ title: "topic", key: topickey || "" }),
          getQuestionBankInstitutionFolders({ title: "topic", key: topickey || "" }),
        ]);

        const subtopics = Array.isArray(subtopicsRes) ? subtopicsRes : [];
        const qbFolders = Array.isArray(foldersRes?.data)
          ? foldersRes.data
          : Array.isArray(foldersRes)
          ? foldersRes
          : [];
        const instQbFolders = Array.isArray(instFoldersRes?.data)
          ? instFoldersRes.data
          : Array.isArray(instFoldersRes)
          ? instFoldersRes
          : [];

        const subtopicFolders = subtopics.map((s) => ({
          ...s,
          _kind: "subtopic",
        }));
        const materialFolders = qbFolders.map((f) => ({
          ...f,
          _kind: "material",
        }));
        const instMaterialFolders = instQbFolders.map((f) => ({
          ...f,
          _kind: "institution_material",
        }));

        setCourseFolders([...subtopicFolders, ...materialFolders]);
        setInstitutionFolders([...subtopicFolders, ...instMaterialFolders]);
      } catch (e) {
        console.error("Failed to load question banks for topic", e);
        setCourseFolders([]);
        setInstitutionFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (topickey) {
      fetchData();
    }
  }, [topickey]);

  const handleOpenFolder = (folder) => {
    if (!folder) return;
    if (folder._kind === "material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/question-bank-folder/${folderId}`);
      return;
    }
    if (folder._kind === "institution_material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/question-bank-folder/${folderId}?type=institution`);
      return;
    }
    if (folder._kind === "subtopic" && (folder.id || folder._id)) {
      const subtopicKey = folder.key || folder.id || folder._id;
      navigate(`/question-bank/${coursekey}/${subjectkey}/${topickey}/${subtopicKey}?tab=${activeTab}`);
      return;
    }
  };

  const currentFolders = activeTab === "institution" ? institutionFolders : courseFolders;

  return (
    <div className="materials-page">
      <div className="materials-header">
        <h1 className="materials-title">Question Bank - Subtopics</h1>
      </div>

      <div className="materials-tabs">
        <button
          type="button"
          className={`materials-tab ${activeTab === "course" ? "active" : ""}`}
          onClick={() => setActiveTab("course")}
        >
          Course Resources
        </button>
        <button
          type="button"
          className={`materials-tab ${activeTab === "institution" ? "active" : ""}`}
          onClick={() => setActiveTab("institution")}
        >
          Institution Resources
        </button>
      </div>

      {loading ? (
        <div className="materials-loading">Loading question banks...</div>
      ) : (
        <MaterialFolderGrid folders={currentFolders} onOpen={handleOpenFolder} />
      )}
    </div>
  );
};

export default QuestionBankTopic;
